import { MIN_QUERY_LENGTH } from '@/features/header/consts/search';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { globalSearchQueries } from './queries';
import type { GlobalSearchRequest } from './schema';

export const useGlobalSearchQuery = (request: GlobalSearchRequest, enabled: boolean) =>
  useQuery({
    ...globalSearchQueries.search(request),
    enabled: enabled && request.Query.trim().length >= MIN_QUERY_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: 0
  });
